import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import type { ClientStatus } from "@/interface/client-account.types";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const isActive = (status: ClientStatus): boolean =>
  status === "Active" || status === 1;

